if (!customElements.get('pdc-product-suggestions')) {
  customElements.define('pdc-product-suggestions', class extends HTMLElement {
    connectedCallback() {
      clearTimeout(this.pdcInitTimer);
      this.pdcInitTimer = setTimeout(() => this.pdcInitialize(), 0);
    }

    pdcInitialize() {
      clearInterval(this.pdcTimer);
      this.pdcTimer = null;
      this.pdcLastKey = null;
      this.pdcCartBusy = false;
      const payload = this.querySelector('[data-pdc-data]');
      if (!payload) return;

      try {
        this.pdcData = JSON.parse(payload.textContent);
      } catch (error) {
        this.querySelector('[data-pdc-status]').textContent =
          'Impossibile leggere i dati dei suggerimenti.';
        return;
      }

      this.pdcRoot = this.pdcData.drawerMode
        ? this.closest('cart-drawer')
        : this.closest('product-form');
      if (!this.pdcRoot) {
        this.querySelector('[data-pdc-status]').textContent =
          'Contenitore del prodotto non trovato.';
        return;
      }

      this.querySelector('[data-pdc-heading]').textContent =
        this.pdcData.heading;

      const safeUpdate = () => {
        try {
          this.pdcUpdate();
        } catch (error) {
          const status = this.querySelector('[data-pdc-status]');
          if (status) {
            status.textContent = 'Errore suggerimenti: ' + error.message;
          }
          this.pdcLastKey = null;
          console.error('PDC suggerimenti:', error);
        }
      };

      safeUpdate();
      this.pdcTimer = setInterval(safeUpdate, 400);
    }

    disconnectedCallback() {
      clearTimeout(this.pdcInitTimer);
      clearInterval(this.pdcTimer);
      this.pdcTimer = null;
    }

    pdcNormalize(value) {
      return String(value == null ? '' : value).trim().toLowerCase();
    }

    pdcOptionIndex(product) {
      return (product.options || []).findIndex(option => {
        const name = typeof option === 'string' ? option : option.name;
        return this.pdcNormalize(name) ===
          this.pdcNormalize(this.pdcData.optionName);
      });
    }

    pdcBuildRow(candidate, initialVariant, size) {
      const data = this.pdcData;
      const availableVariants = (candidate.variants || []).filter(item => item.available);
      this.pdcSelections = this.pdcSelections || new Map();
      let variant = initialVariant;
      if (data.manual) {
        const savedId = this.pdcSelections.get(String(candidate.id));
        variant = availableVariants.find(item => String(item.id) === savedId) || initialVariant;
      }

      const row = document.createElement('div');
      row.className = 'pdc-suggestion-row';
      const link = document.createElement('a');
      const rootUrl = (data.rootUrl || '/').replace(/\/?$/, '/');
      const productPath = candidate.url || rootUrl + 'products/' + encodeURIComponent(candidate.handle);
      const url = new URL(productPath, window.location.origin);
      url.searchParams.set('variant', String(variant.id));
      link.href = url.pathname + url.search;
      link.className = 'pdc-suggestion-link';

      const imageSource = variant.featured_image || candidate.featured_image;
      const imageUrl = typeof imageSource === 'string' ? imageSource : imageSource && imageSource.src;
      if (imageUrl) {
        const image = document.createElement('img');
        image.src = imageUrl;
        image.alt = candidate.title;
        image.loading = 'lazy';
        image.className = 'pdc-suggestion-image';
        link.append(image);
      }

      const info = document.createElement('div');
      info.className = 'pdc-suggestion-info';
      const title = document.createElement('div');
      title.className = 'pdc-suggestion-title';
      title.textContent = candidate.title;
      info.append(title);
      if (!data.manual) {
        const sizeLabel = document.createElement('div');
        sizeLabel.className = 'pdc-suggestion-size';
        sizeLabel.textContent = 'Taglia ' + size;
        info.append(sizeLabel);
      }
      link.append(info);

      const prices = document.createElement('div');
      prices.className = 'pdc-suggestion-prices';
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'it-IT', {
        style: 'currency', currency: data.currency
      });
      const currentPrice = Number(variant.price);
      const originalPrice = Number(variant.compare_at_price);
      if (originalPrice > currentPrice) {
        const original = document.createElement('s');
        original.className = 'pdc-suggestion-original-price';
        original.textContent = formatter.format(originalPrice / 100);
        prices.append(original);
      }
      const price = document.createElement('span');
      price.className = 'pdc-suggestion-current-price';
      if (originalPrice > currentPrice) price.classList.add('pdc-suggestion-sale-price');
      price.textContent = formatter.format(currentPrice / 100);
      prices.append(price);
      if (Number.isFinite(originalPrice) && Number.isFinite(currentPrice) &&
          originalPrice > 0 && currentPrice >= 0 && originalPrice > currentPrice) {
        const discountPercent = Math.floor(((originalPrice - currentPrice) * 100 / originalPrice) + 1e-9);
        if (discountPercent >= 1) {
          const badge = document.createElement('span');
          badge.className = 'pdc-suggestion-discount-badge';
          badge.textContent = '−' + discountPercent + '%';
          badge.setAttribute('aria-label', 'Sconto del ' + discountPercent + '%');
          Object.assign(badge.style, {
            display: 'inline-block', alignSelf: 'flex-end',
            width: 'fit-content', marginTop: '4px', padding: '2px 6px',
            borderRadius: '4px', backgroundColor: '#fff4e5',
            color: '#9a4700', fontSize: '12px', fontWeight: '700',
            lineHeight: '1.4', whiteSpace: 'nowrap'
          });
          prices.append(badge);
        }
      }
      link.append(prices);
      row.append(link);

      if (data.manual) {
        const controls = document.createElement('div');
        controls.className = 'pdc-variant-controls';
        const note = document.createElement('p');
        note.className = 'pdc-variant-note';
        note.setAttribute('aria-live', 'polite');

        (candidate.options || []).forEach((option, index) => {
          const name = typeof option === 'string' ? option : option.name;
          const values = Array.from(new Set(availableVariants.map(item => item.options[index])));
          if (values.length === 0 || (name === 'Title' && values.length === 1 && values[0] === 'Default Title')) return;

          const label = document.createElement('label');
          label.className = 'pdc-variant-label';
          const labelText = document.createElement('span');
          labelText.textContent = name;
          const select = document.createElement('select');
          select.className = 'pdc-variant-select';
          select.setAttribute('data-pdc-option', String(index));
          select.setAttribute('aria-label', name + ' per ' + candidate.title);
          values.forEach(value => {
            const choice = document.createElement('option');
            choice.value = value;
            choice.textContent = value;
            select.append(choice);
          });
          select.value = variant.options[index];
          select.addEventListener('change', event => {
            event.stopPropagation();
            const chosenValue = select.value;
            const desiredOptions = variant.options.slice();
            desiredOptions[index] = chosenValue;
            const exactVariant = availableVariants.find(item => item.options.every((value, position) => value === desiredOptions[position]));
            const nextVariant = exactVariant || availableVariants.find(item => item.options[index] === chosenValue);
            if (!nextVariant) {
              select.value = variant.options[index];
              note.textContent = 'Questa combinazione non è disponibile.';
              return;
            }
            this.pdcSelections.set(String(candidate.id), String(nextVariant.id));
            const replacement = this.pdcBuildRow(candidate, nextVariant, size);
            if (!exactVariant) {
              replacement.querySelector('.pdc-variant-note').textContent =
                'Selezionata una combinazione disponibile: ' + nextVariant.options.join(' / ') + '.';
            }
            row.replaceWith(replacement);
            const updatedSelect = replacement.querySelector('[data-pdc-option="' + index + '"]');
            if (updatedSelect) updatedSelect.focus({ preventScroll: true });
          });
          label.append(labelText, select);
          controls.append(label);
        });
        if (controls.childElementCount > 0) {
          row.append(controls, note);
        }
      }
      const actions = document.createElement('div');
      actions.className = 'pdc-cart-actions';
      const addButton = document.createElement('button');
      addButton.type = 'button';
      addButton.className = 'btn btn--primary pdc-cart-button';
      addButton.setAttribute('data-pdc-add', '');
      addButton.textContent = variant.available ? 'Aggiungi al carrello' : 'Non disponibile';
      addButton.disabled = !variant.available || Boolean(candidate.requires_selling_plan);
      const feedback = document.createElement('p');
      feedback.className = 'pdc-cart-feedback';
      feedback.setAttribute('role', 'status');
      feedback.setAttribute('aria-live', 'polite');
      if (candidate.requires_selling_plan) {
        feedback.textContent = 'Apri il prodotto per scegliere il piano di acquisto.';
      }
      addButton.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        this.pdcAddToCart(variant, addButton, feedback);
      });
      actions.append(addButton);
      row.append(actions, feedback);
      return row;
    }

    async pdcAddToCart(variant, button, feedback) {
      if (this.pdcCartBusy || !variant.available) return;
      this.pdcCartBusy = true;
      const controls = Array.from(this.querySelectorAll('[data-pdc-add], .pdc-variant-select'));
      const states = controls.map(control => ({ control, disabled: control.disabled }));
      controls.forEach(control => { control.disabled = true; });
      button.textContent = 'Aggiunta in corso…';
      button.setAttribute('aria-busy', 'true');
      feedback.textContent = '';
      feedback.classList.remove('pdc-cart-error');

      try {
        const rootUrl = (this.pdcData.rootUrl || '/').replace(/\/?$/, '/');
        const baseUrl = this.pdcData.cartAddUrl || rootUrl + 'cart/add';
        const endpoint = baseUrl.endsWith('.js') ? baseUrl : baseUrl + '.js';
        const response = await fetch(endpoint, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: String(variant.id),
              quantity: 1,
              properties: {
                _pdc_source: this.pdcData.drawerMode ? 'carrello' : 'scheda_prodotto',
                _pdc_group: String(this.pdcData.attributionHandle || ''),
                _pdc_type: this.pdcData.manual ? 'gruppo' : 'regola'
              }
            }]
          })
        });
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          const description = errorData.description || errorData.message;
          const error = new Error(typeof description === 'string' ? description : 'Articolo non aggiunto. Verifica la disponibilità.');
          error.pdcConfirmedFailure = true;
          throw error;
        }
        button.textContent = 'Aggiunto ✓';
        feedback.textContent = 'Articolo aggiunto. Aggiorno il carrello…';
        button.removeAttribute('aria-busy');
        if (this.pdcData.drawerMode) {
          const drawer = this.closest('cart-drawer');
          const form = drawer && drawer.querySelector('cart-form');
          if (form && typeof form.refresh === 'function') {
            try {
              await form.refresh();
            } catch (refreshError) {
              feedback.textContent = 'Articolo aggiunto. Ricarica la pagina per aggiornare il carrello.';
              console.error('PDC aggiornamento carrello:', refreshError);
            }
          } else {
            feedback.textContent = 'Articolo aggiunto. Ricarica la pagina per aggiornare il carrello.';
          }
          // L'aggiunta è riuscita: non ripetere la richiesta se il refresh fallisce.
        } else {
          setTimeout(() => window.location.reload(), 1200);
        }
      } catch (error) {
        feedback.textContent = error.pdcConfirmedFailure
          ? error.message
          : 'Non riesco a confermare l’aggiunta. Controlla il carrello prima di riprovare.';
        feedback.classList.add('pdc-cart-error');
        button.textContent = 'Aggiungi al carrello';
        button.removeAttribute('aria-busy');
        states.forEach(state => { state.control.disabled = state.disabled; });
        this.pdcCartBusy = false;
      }
    }

    pdcUpdate() {
      if (this.pdcCartBusy) return;
      const data = this.pdcData;
      const inputs = data.drawerMode ? [] : this.pdcRoot.querySelectorAll('[name="id"]');
      let selectedVariant = null;

      for (const input of inputs) {
        selectedVariant = data.current.variants.find(
          variant => String(variant.id) === String(input.value)
        );
        if (selectedVariant) break;
      }

      if (!selectedVariant) {
        selectedVariant = data.current.variants.find(
          variant => String(variant.id) === String(data.initialVariant)
        );
      }

      const key = selectedVariant ? String(selectedVariant.id) : 'none';
      if (this.pdcLastKey === key) return;
      this.pdcLastKey = key;

      const status = this.querySelector('[data-pdc-status]');
      const results = this.querySelector('[data-pdc-results]');
      results.replaceChildren();

      if (!data.configured) {
        status.textContent = '';
        this.hidden = true;
        return;
      }
      this.hidden = false;

      const currentIndex = this.pdcOptionIndex(data.current);
      let size = '';

      if (!data.manual) {
        if (currentIndex < 0 || !selectedVariant) {
          status.textContent =
            'Test: verifica il nome dell’opzione taglia nella regola.';
          return;
        }
        size = selectedVariant.options[currentIndex];
      }

      let count = 0;
      const limit = Math.max(1, Number(data.limit) || 4);
      const seen = new Set();

      for (const candidate of data.products) {
        if (count >= limit) break;
        if (candidate.id === data.current.id || seen.has(candidate.id)) continue;
        if (data.drawerMode && (data.cartProductIds || []).some(id => String(id) === String(candidate.id))) continue;

        const index = this.pdcOptionIndex(candidate);
        const variant = (candidate.variants || []).find(item => {
          if (data.manual) return item.available;
          if (index < 0) return false;
          const sameSize = this.pdcNormalize(item.options[index]) ===
            this.pdcNormalize(size);
          return sameSize && (!data.onlyAvailable || item.available);
        });

        if (!variant) continue;
        seen.add(candidate.id);

        results.append(this.pdcBuildRow(candidate, variant, size));
        count++;

      }

      status.style.whiteSpace = 'pre-line';
      if (count > 0) {
        status.textContent = data.ctaText || '';
        status.hidden = !status.textContent.trim();
      } else {
        if (data.drawerMode) {
          this.hidden = true;
          status.textContent = '';
          return;
        }
        status.hidden = false;
        status.textContent = data.manual
          ? 'Nessun abbinamento acquistabile.'
          : 'Nessuna alternativa trovata nella taglia ' + size + '.';
      }
    }
  });
}

if (!window.pdcDrawerReminderEventsBound) {
  window.pdcDrawerReminderEventsBound = true;
  document.addEventListener('on:cart:after-merge', event => {
    const target = event.target;
    const drawer = target && typeof target.closest === 'function' ? target.closest('cart-drawer') : null;
    const scope = drawer || document;
    scope.querySelectorAll('cart-drawer pdc-product-suggestions, pdc-product-suggestions').forEach(element => {
      if (!element.closest('cart-drawer')) return;
      clearTimeout(element.pdcInitTimer);
      element.pdcInitTimer = setTimeout(() => {
        if (element.isConnected && typeof element.pdcInitialize === 'function') element.pdcInitialize();
      }, 0);
    });
  }, true);
}
